import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import '../../Views/User/profilepage/Profilesettings.css';
import bell from '../../assets/notification.png';
import gal from '../../assets/gallery.png';
import { useTranslation } from 'react-i18next';
import axiosUserInstance from '../../axiosUserInstance';
import { toast } from 'react-toastify';
import { useCart } from '../../CartProvider';
import MobileBackIcon from '../../assets/svg/MobileBackIcon';
import VendorTopMenuBar from './VendorLayouts/VendorTopMenuBar';
import VendorSideMenuBar from './VendorLayouts/VendorSideMenuBar';

export default function VendorEditprofile() {
    const [profileImage, setProfileImage] = useState(null); 
    const [userImagePreview, setUserImagePreview] = useState();
    const { t } = useTranslation();
   
    const [isLoading, setIsLoading] = useState(false); 
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [dob, setDob] = useState(null);
    const [username, setUsername] = useState('');
    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [dobError, setDobError] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [disableButton, setDisableButton] = useState(true);
    const [initialValues, setInitialValues] = useState({});
    const { setVendorUserData, fetchVendorUserProfile } = useCart();
    const nameRegex = /^[A-Za-z]{2,}$/;

    useEffect(() => {
        if (firstNameError || lastNameError || usernameError || dobError || !firstName || !lastName || !username || !dob) {
            setDisableButton(true);
        } else {
            setDisableButton(false);
        }
    }, [firstNameError, lastNameError, usernameError, dobError, firstName, lastName, username, dob]);

    useEffect(() => {
        axiosUserInstance
            .get('/auth/user/userbyId')
            .then((response) => {
                const data = response?.data?.user;
                const formattedDate = data?.DOB
                    ? data?.DOB.split('T')[0]
                    : '';

                const initialData = {
                    firstName: data?.first_name || '',
                    lastName: data?.last_name || '',
                    username: data?.username || '',
                    dob: formattedDate,
                    profileImagePreview: data?.profile_picture,
                };

                setFirstName(initialData?.firstName);
                setLastName(initialData?.lastName);
                setUsername(initialData?.username);
                setDob(initialData?.dob);
                setUserImagePreview(initialData?.profileImagePreview);
                setInitialValues(initialData);
            })
            .catch((error) => console.error('Error fetching user data:', error));
    }, []);

    useEffect(() => {
        const isChanged =
                firstName !== initialValues?.firstName ||
                lastName !== initialValues?.lastName ||
                username !== initialValues?.username ||
                dob !== initialValues?.dob ||
                profileImage !== null; 
        
        if (firstNameError || lastNameError || usernameError || dobError || !isChanged) {
            setDisableButton(true);
        } else {
            setDisableButton(false);
        }
    }, [firstName, lastName, username, dob, profileImage, firstNameError, lastNameError, usernameError, dobError]);

    const handleGalleryClick = (e) => {
        const file = e.target.files[0]; 
        if (file) {
            setProfileImage(file);

            const reader = new FileReader();
            reader.onload = () => {
                setUserImagePreview(reader.result); 
            };
            reader.readAsDataURL(file);
        }
    };

    const handleFirstNameChange = (e) => {
        const value = e.target.value;
        if (!value) {
            setFirstNameError('First name cannot be blank');
        } else if (!nameRegex.test(value)) {
            setFirstNameError('Invalid First name');
        } else if (value.length > 50) {
            setFirstNameError('First name cannot be longer than 50 characters');
        } else {
            setFirstNameError('');
        }
        setFirstName(value);
    };

    const handleLastNameChange = (e) => {
        const value = e.target.value;
        if (!value) {
            setLastNameError('Last name cannot be blank');
        } else if (!nameRegex.test(value)) {
            setLastNameError('Invalid Last name');
        }else if (value.length > 50) {
            setLastNameError('Last name cannot be longer than 50 characters');
        } else {
            setLastNameError('');
        }
        setLastName(value);
    };

    const handleUsernameChange = (e) => {
        const value = e.target.value;
        const usernameRegex = /^[a-z0-9_]+$/;    
        if (!value) {
            setUsernameError('Please enter username');
        } else if (!usernameRegex.test(value)) {
            setUsernameError('Invalid username. Only a-z ,0-9 & UnderScores "_" are allowed.');
        } else {
            setUsernameError('');
        }
        setUsername(value);
    };

    const handleSaveChanges = () => {
        let isValid = true;
        const usernameRegex = /^[a-zA-Z0-9_]+$/;


        if (!firstName) {
            setFirstNameError('First name cannot be blank');
            isValid = false;
        } else if (!nameRegex.test(firstName)) {
            setFirstNameError('Invalid First name');
            isValid = false;
        }else if (firstName.length > 50) {
            setFirstNameError('First name cannot be longer than 50 characters');
            isValid = false;
        }

        if (!lastName) {
            setLastNameError('Last name cannot be blank');
            isValid = false;
        } else if (!nameRegex.test(lastName)) {
            setLastNameError('Invalid Last name');
        }else if (lastName.length > 50) {
            setLastNameError('Last name cannot be longer than 50 characters');
            isValid = false;
        }

        if (!username) {
            setUsernameError('Please enter username');
            isValid = false;
        } else if (!usernameRegex.test(username)) {
            setUsernameError('Invalid username. Only a-z ,0-9 & UnderScores "_" are allowed.');
        }

        if (!dob) {
            setDobError('Please enter date of birth');
            isValid = false;
        }

        if (isValid) {

            if (isLoading) return; 
            setIsLoading(true); 
           
            const formData = new FormData();
            formData.append('first_name', firstName);
            formData.append('last_name', lastName);
            formData.append('username', username);
            formData.append('DOB', dob);

            if (profileImage) {
                formData.append('profile_picture', profileImage); 
            }

            setIsLoading(true);
            axiosUserInstance
                .put('/auth/update/updatebyuserid', formData)
                .then((response) => {
                    setIsLoading(false);
                    if (response?.data?.updatedUser?.profile_picture) {
                        fetchVendorUserProfile();
                    }
                    setVendorUserData(response?.data);
                    toast.success('Profile updated successfully');
                    
                    const updatedData = {
                        firstName,
                        lastName,
                        username,
                        dob,
                        profileImagePreview: profileImage ? URL.createObjectURL(profileImage) : userImagePreview,
                    };
                            
                    setInitialValues(updatedData);
                    setDisableButton(true);
                })
                .catch((error) => {
                    console.error('Error saving changes:', error);
                }).finally(()=>{
                    setIsLoading(false);
                });
        }
    };

    const imageURL = userImagePreview?.trim() ? userImagePreview : null;
    const fallbackLetter = (firstName.charAt(0) + (lastName?.charAt(0) || '')).toUpperCase();

    const goBack = () => {
        window.history.back();
    };

    return (
        <>
            <div className="vendor-header-footer">
                <VendorTopMenuBar />
                <VendorSideMenuBar />
            </div>
            <div className="editprofile-top-mainn">
                <div className="edit-profile-main-c">
                    <div className="edit-profile-top1">
                        <div className="back-button11" onClick={() => goBack()}>
                            <div className="ico1">
                                <MobileBackIcon />
                            </div>
                        </div>
                        <div className="edit-profile-text-layout">
                            <h5 className="edit-profile-text">
                                {t('editprofile.editprofile-title')}
                            </h5>
                        </div>
                        <img src={bell} alt="bell" className="msg-icon" />
                    </div>
                    <div className="edit-profile-bottom">
                        <div className="profile-gallary-container">
                            
                            <div className='edit-profile-photo'>
                                {imageURL ? (
                                    <img src={userImagePreview} className="profile-photo" alt="Profile" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit:'cover' }} />
                                ) : (
                                    <span>{fallbackLetter}</span>
                                )}
                            </div>
                            <div className="gallary-container">
                                <input
                                    type="file"
                                    id="fileInput"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={handleGalleryClick}
                                />
                                <label htmlFor="fileInput" className="edit-profile-upload">
                                    <img src={gal} alt="gallery-icon" className="gallary-img" />
                                </label>
                            </div>
                        </div>
                        <form className="person-data-container">
                            <div className="name-container">
                                <div className="firstname-container">
                                    <p className="profile-head-text">
                                        {t('editprofile.first-name-title')}
                                    </p>
                                    <TextField
                                        className="txtfld-1"
                                        placeholder={t('editprofile.first-name-placeholder')}
                                        value={firstName}
                                        onChange={handleFirstNameChange}
                                        error={!!firstNameError}
                                        helperText={firstNameError}
                                    />
                                </div>
                                <div className="lastname-container">
                                    <p className="profile-head-text">
                                        {t('editprofile.last-name-title')}
                                    </p>
                                    <TextField
                                        placeholder={t('editprofile.last-name-placeholder')}
                                        value={lastName}
                                        onChange={handleLastNameChange}
                                        error={!!lastNameError}
                                        helperText={lastNameError}
                                    />
                                </div>
                            </div>
                            <div className="username-container">
                                <p className="profile-head-text">
                                    {t('editprofile.username-title')}
                                </p>
                                <TextField
                                    placeholder={t('editprofile.username-placeholder')}
                                    value={username}
                                    onChange={handleUsernameChange}
                                    error={!!usernameError}
                                    helperText={usernameError}
                                />
                            </div>

                            <div className="save-changes-layout">
                                <Button
                                    variant="contained"
                                    style={{
                                        backgroundColor: disableButton ? 'gray' : 'var(--color4)', 
                                        cursor: disableButton ? 'not-allowed' : 'pointer',
                                        opacity: disableButton ? 0.7 : 1 
                                    }}
                                    onClick={handleSaveChanges}
                                    className="save-changes-button"
                                    disabled={disableButton}
                                >
                                    {isLoading ? ' Updating....' : 'Save Changes'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

